import * as THREE from 'three';
import gsap from 'gsap';

export default class Raycaster {
  static instance;

  constructor() {
    if (Raycaster.instance) {
      return Raycaster.instance;
    }
    Raycaster.instance = this;

    this.parent;
    this.raycaster = new THREE.Raycaster();
    this.mouse = new THREE.Vector2();
    this.needUpdate = false;

    // Select
    this.raycastBox = true;
    this.boxList = [];
    this.elementList = [];

    this.isHover = false;
    this.saveID = 0;
    this.currentID = 0;

    this.hoverElement = null;
  }

  setEvents(parent) {
    this.parent = parent;

    this.parent.canvas.addEventListener('mousemove', (event) => {
      this.setMousePosition(event.clientX, event.clientY);
      this.needUpdate = true;
    });
    this.parent.canvas.addEventListener('touchmove', (event) => {
      this.setMousePosition(event.changedTouches[0].clientX, event.changedTouches[0].clientY);
      this.needUpdate = true;
    });
    this.parent.canvas.addEventListener('click', () => {
      if (this.isHover) {
        this.saveID = this.currentID;
      }
    });
  }

  setMousePosition(x, y) {
    x -= this.parent.sizes.box.left;
    y -= this.parent.sizes.box.top;

    this.mouse.x = (x / this.parent.sizes.width) * 2 - 1;
    this.mouse.y = -(y / this.parent.sizes.height) * 2 + 1;
  }

  refreshLists() {
    this.boxList = [];
    this.elementList = [];

    for (let i = 0; i < this.parent.dressing.content.length; i++) {
      this.boxList.push(this.parent.dressing.content[i].hitBox);
      this.parent.dressing.content[i].hitBox.name = i;
    }
  }

  update() {
    if (this.needUpdate) {
      this.needUpdate = false;

      // Raycast
      this.raycaster.setFromCamera(this.mouse, this.parent.camera);
      const intersect = this.raycaster.intersectObjects(this.raycastBox ? this.boxList : this.elementList);
      if (intersect.length > 0) {
        this.elementHovered(this.parent.dressing.content[intersect[0].object.name].obj);
      } else if (this.hoverElement) {
        this.hoverElement = null;
        this.resetElement();

        if (this.isHover) {
          this.parent.dressing.refreshUICurrentBox(this.saveID);
          document.body.style.cursor = 'default';
        }

        this.isHover = false;
      }
    }
  }

  elementHovered(object) {
    if (object === this.hoverElement) {
      return;
    }
    this.hoverElement = object;

    // Set Box texture
    for (const box of this.parent.dressing.content) {
      if (box.obj.uuid === object.uuid) {
        if (!this.isHover) {
          this.saveID = this.parent.dressing.getUIid();
          document.body.style.cursor = 'pointer';
        }
        this.isHover = true;

        this.currentID = box.position;
        this.parent.dressing.refreshUICurrentBox(box.position);

        this.setOpacity(box.obj.material, 1);
        this.setChildOpacity(box.content, 1);
      } else {
        this.setOpacity(box.obj.material, 0.4);
        this.setChildOpacity(box.content, 0.4);
      }
    }
  }

  resetElement() {
    for (const box of this.parent.dressing.content) {
      this.setOpacity(box.obj.material, 1);
      this.setChildOpacity(box.content, 1);
    }
  }

  setChildOpacity(contentList, opacity) {
    for (const child of contentList) {
      this.setOpacity(child.obj.material, opacity);
    }
  }

  setOpacity(material, value) {
    gsap.to(material, {
      opacity: value,
      duration: 0.2,
    });
  }
}
